import React from 'react'

const Footer = () => {

    return (
        <footer className="bg-opacity-80 bg-cyan-800 text-cyan-100 mt-10 p-10 shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]">
            <div className="flex flex-row justify-between">
                <div className="flex items-center font-semibold">
                    <h2 className="text-4xl">cameron</h2>
                </div>
            </div>
        </footer>
    )
}

export default Footer